import { ChevronLeft, ChevronRight } from 'lucide-react';

import { Button } from '@/components/ui/Button';

interface PaginationProps {
  page: number;
  totalPages: number;
  isLoading: boolean;
  onPageChange: (newPage: number) => void;
}

export function Pagination({
  page,
  totalPages,
  isLoading,
  onPageChange,
}: PaginationProps) {
  const isFirstPage = page <= 1;
  const isLastPage = page >= totalPages;

  return (
    <div className="mt-6 flex flex-row items-center justify-between gap-2">
      <span className="text-sm text-muted-foreground">
        Page <span className="font-medium">{page}</span> de{' '}
        <span className="font-medium">{totalPages}</span>
      </span>

      <div className="flex items-center gap-1">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onPageChange(page - 1)}
          disabled={isFirstPage || isLoading}
          className="rounded-xl transition-all hover:bg-gray-200 hover:text-gray-900 disabled:opacity-40"
        >
          <ChevronLeft className="h-4 w-4 hover:stroke-[2.5]" />
        </Button>

        <span className="px-3 text-sm font-semibold text-foreground">
          {page}
        </span>

        <Button
          variant="ghost"
          size="icon"
          onClick={() => onPageChange(page + 1)}
          disabled={isLastPage || isLoading}
          className="rounded-xl transition-all hover:bg-gray-200 hover:text-gray-900 disabled:opacity-40"
        >
          <ChevronRight className="h-4 w-4 hover:stroke-[2.5]" />
        </Button>
      </div>
    </div>
  );
}
